import { WholesalerArticle } from "@tm/models"
import { PropsWithChildren, memo } from "react"
import { ArticleItem, ArticleItemStateProvider } from "@tm/components"
import { useCarouselWholesalerArticleItem } from "./useCarouselWholesalerArticleItem"

type WholesalerArticleItemProps = PropsWithChildren<{
    article: WholesalerArticle
    workTaskId: string
    requestPartList(showAddToBasketMessage?: boolean): void
}>

const CarouselWholesalerArticleItemStateProvider = memo(({ article, children, workTaskId, requestPartList }: WholesalerArticleItemProps) => {
    const state = useCarouselWholesalerArticleItem(article, workTaskId, requestPartList)

    return <ArticleItemStateProvider value={state}>{children}</ArticleItemStateProvider>
})

export function CarouselWholesalerArticleItem({ article, workTaskId, requestPartList }: WholesalerArticleItemProps) {
    return (
        <CarouselWholesalerArticleItemStateProvider article={article} workTaskId={workTaskId} requestPartList={requestPartList}>
            <ArticleItem variant="WholesalerArticle" />
        </CarouselWholesalerArticleItemStateProvider>
    )
}
